import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SingleValueChartComponent } from "./single-value-chart/single.value.chart.component";
import { CommonMaterialModule } from "@nrwl/common-material";
import { CommonLibModule } from "@nrwl/common-lib";

@NgModule({
  imports: [CommonModule, CommonMaterialModule, CommonLibModule],
  declarations: [SingleValueChartComponent],
  exports: [SingleValueChartComponent]
})
export class SingleValueChartModule {
}
